import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// import { getMessaging } from "firebase/messaging/sw";
// import { getMessaging } from "firebase/messaging";
import { onBackgroundMessage, getMessaging, isSupported } from "firebase/messaging/sw";
import { getToken, onMessage } from "firebase/messaging";
const firebaseConfig = {
  apiKey: "AIzaSyBspkc1_BO0t1zZckeQq2afyIc2TZbFc7M",
  authDomain: "arch-chat-ec653.firebaseapp.com",
  projectId: "arch-chat-ec653",
  storageBucket: "arch-chat-ec653.appspot.com",
  messagingSenderId: "772791222627",
  appId: "1:772791222627:web:2516ea77a96e3ffaebd356",
  measurementId: "G-380PRBMNB6"
};
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth();
export const storage = getStorage();
export const db = getFirestore(app);
// const messaging = getMessaging(firebaseConfig);
// export const messaging = getMessaging(app);
const firebaseApp = initializeApp(firebaseConfig);
const messaging = (async () => {
  try {
    const isSupportedBrowser = await isSupported();
    if (isSupportedBrowser) {
      return getMessaging(firebaseApp);
    }
    console.log("Firebase not supported this browser");
    return null;
  } catch (err) {
    console.log(err);
    return null;
  }
})();


export const getTokenB = async (setTokenFound) => {
  try {
    const messagingResolve = await messaging;
    const currentToken = await getToken(messagingResolve, {
      vapidKey: "BLs3z0wzdZfujEcqs8CjAJLDu-4ZqM0FRYgWZiyoLn2unL9Gq_LVJvjcULyw_0_2_kD7q6-zpdLQ8nKOi3R307M",
    });
    if (currentToken) {
      console.log("current token for client: ", currentToken);
      setTokenFound(currentToken);
    }
  } catch (err) {
    console.log("An error occurred while retrieving token. ", err);
  }
};
export const onMessageListener = async () =>
  new Promise((resolve) =>
    (async () => {
      const messagingResolve = await messaging;
      onMessage(messagingResolve, (payload) => {
        console.log('On message: ', messaging, payload);
        resolve(payload);
      });
    })()
  );